module.exports = __webpack_public_path__ + "img/ps-vivienda.125163db.jpg";